import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastPrimitivesProvider,
  ToastViewport,
} from './toast-primitives';
import { toneToVariant, useToast } from './use-toast';

export function Toaster() {
  const { toasts, dismiss } = useToast();

  return (
    <ToastPrimitivesProvider swipeDirection="right" duration={4000}>
      {toasts.map(({ id, message, tone, open }) => (
        <Toast
          key={id}
          open={open}
          variant={toneToVariant(tone)}
          onOpenChange={(nextOpen) => {
            if (!nextOpen) dismiss(id);
          }}
        >
          <ToastDescription>{message}</ToastDescription>
          <ToastClose />
        </Toast>
      ))}
      <ToastViewport />
    </ToastPrimitivesProvider>
  );
}
